import React from 'react'
import {LocationDetailsMap} from '@therms/react-modules'

export function LocationDetailsMapScreen() {
  return <LocationDetailsMap showLocationHistory />
}
